export default () => ({
  cities: [],
  states: [],
  colonies: [],
})
